import{useRoutingContext as t}from"../context/RoutingContext.js";function e(){const{router:e}=t();return{push:e.push,replace:e.replace}}export{e as useLocation};
//# sourceMappingURL=use-location.js.map
